import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "bg-white shadow-md ring-1 ring-gray-900/5 rounded-xl md:col-span-3 mx-auto w-3/5" }
const _hoisted_2 = { class: "px-4 py-6 sm:p-8" }
const _hoisted_3 = { class: "grid max-w-2xl grid-cols-1 gap-x-6 gap-y-8 sm:grid-cols-6 mx-auto" }

import {useForm} from 'vee-validate';
import {PropType, reactive, watch} from 'vue';
import * as yup from 'yup';

import InputField from "@/components/Atomic/AQuarks/InputField.vue";
import Dropdown from "@/components/Atomic/AQuarks/Dropdown.vue";
import {BankDetailDto} from "@/areas/schools/dtos/bankDetailDto";
import {BankAccountTypeEnum} from "@/areas/schools/enums/bankAccountTypeEnum";


export default /*#__PURE__*/_defineComponent({
  __name: 'BankDetailsForm',
  props: {
  bankDetails: {
    type: Object as PropType<BankDetailDto>,
    required: true,
  },
  showErrors: {
    type: Boolean,
    default: false,
  }
},
  emits: ['update', 'has-error'],
  setup(__props, { emit: __emit }) {

const props = __props

const emit = __emit

const bankAccountTypeOptions = Object.values(BankAccountTypeEnum)

const bankDetailsForm = reactive(props.bankDetails)

watch(() => props.bankDetails, (newValue) => {
  bankDetailsForm.name = newValue?.name  ?? ''
  bankDetailsForm.branchCode = newValue?.branchCode  ?? ''
  bankDetailsForm.bankAccountType = newValue?.bankAccountType ?? BankAccountTypeEnum.Cheque
  bankDetailsForm.accountNumber = newValue?.accountNumber  ?? ''
}, { deep: true, immediate: true })

// Form validation
const validationSchema = yup.object({
  name: yup.string().required('Bank Name is required'),
  branchCode: yup.string().required('Branch Code is required'),
  bankAccountType: yup.mixed().oneOf(bankAccountTypeOptions).required('Bank Account Type is required'),
  accountNumber: yup.string().required('Bank Account Number is required')
})

const bankDetailsFormFields = useForm({
  validationSchema: validationSchema,
  initialValues:bankDetailsForm 
})

watch(() => bankDetailsForm, async (newVal) => {
  // Reset the form with new values
  bankDetailsFormFields.resetForm({
    values: newVal,
    errors: {}, // Optionally reset errors
    touched: {} // Optionally reset touched fields
  });

  emit('update', bankDetailsForm)
  const validationResult = await bankDetailsFormFields.validate();
  emit('has-error', !validationResult.valid)
  
}, { immediate: true, deep: true });

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("form", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(InputField, {
          class: "sm:col-span-3",
          label: "Bank Name*",
          placeholder: "Bank Name",
          "error-message": __props.showErrors ? _unref(bankDetailsFormFields).errors.value['name'] : undefined,
          modelValue: bankDetailsForm.name,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((bankDetailsForm.name) = $event)),
          required: ""
        }, null, 8, ["error-message", "modelValue"]),
        _createVNode(InputField, {
          class: "sm:col-span-3",
          label: "Branch Code*",
          placeholder: "Branch Code",
          "error-message": __props.showErrors ? _unref(bankDetailsFormFields).errors.value['branchCode'] : undefined,
          modelValue: bankDetailsForm.branchCode,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((bankDetailsForm.branchCode) = $event)),
          required: ""
        }, null, 8, ["error-message", "modelValue"]),
        _createVNode(Dropdown, {
          class: "sm:col-span-3",
          label: "Account Type*",
          placeholder: "Select Account Type",
          "error-message": __props.showErrors ? _unref(bankDetailsFormFields).errors.value['bankAccountType'] : undefined,
          options: _unref(bankAccountTypeOptions),
          modelValue: bankDetailsForm.bankAccountType,
          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((bankDetailsForm.bankAccountType) = $event))
        }, null, 8, ["error-message", "options", "modelValue"]),
        _createVNode(InputField, {
          class: "sm:col-span-3",
          label: "Account Number*",
          placeholder: "Account Number",
          "error-message": __props.showErrors ? _unref(bankDetailsFormFields).errors.value['accountNumber'] : undefined,
          modelValue: bankDetailsForm.accountNumber,
          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((bankDetailsForm.accountNumber) = $event)),
          required: ""
        }, null, 8, ["error-message", "modelValue"])
      ])
    ])
  ]))
}
}

})